export default "/images/fb98fb434803cbf2a5fabcff685583bd.avif";